export default "__VITE_ASSET__CW$OYx_n__"